
/**
 * Determina si un objeto contiene todas las propiedades del array
 * Si todas las propiedades están contenidas en el objeto, devuelve true, sino false
 * Es case sensitive
 * @param {Object} object Objeto json del cual se consultarán las propiedades
 * @param {string[]} props Array de string con las propiedades a buscar
 */
export const existAllProps = (object, props) => {

    const result = Object.keys(object).filter(key => props.includes(key));

    return result.length === props.length;
};

/**
 * Determina si el valor es un número
 * @param {String} value Valor para chequear si es un número
 */
export const isNumber = (value) => {

    const cast = Number(value);

    return !isNaN(cast);
};

/**
 * Genera un uid random
 */
export const generateRandomUidv4 = () => {

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r && 0x3 | 0x8);
        return v.toString(16);
    });
};

/**
 * Formatea un número agregándole los puntos de miles
 * @param {number} number Número a formatear
 */
export const formatNumber = (number) => {

    if (number === undefined) { return null; }

    return new Intl.NumberFormat('es-AR', {
        currency: 'ARS'
    }).format(number);
};

/**
 * Formatea un número agregándole los puntos de miles y comas de un decimal.
 * @param {number} number Número a formatear
 */
export const formatAmountNumber = (number) => {

    if (number === undefined) { return null; }

    return new Intl.NumberFormat('es-AR', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
        useGrouping: true,
        currency: 'ARS',
    }).format(number)?.replace(/[\s\u00A0$]/g, '');
};

/**
 * Calcula la longitud de digitos decimales y enteros de un número
 * @param {number} number Número a formatear
 */
export const getDecimalsAndIntegerLength = (number) => {

    const [integerPart, decimalPart = ""] = Math.abs(number).toString().split(".");

    return {
        integerLength: integerPart.length,
        decimalLength: decimalPart.replace(/0+$/, "").length // ver si queremos eliminar ceros al final.
    };
};

/**
 * Obtiene el valor de la propiedad del objeto por la key desde dos fuentes, si está en la primera,
 * obtiene la primera sino busca en el segundo objeto
 * @param {Object} primary Objeto primario
 * @param {Object} secondary Objeto secundario
 * @param {String} key Nombre de la propidad a verificar
 */
export const resolveValueByKey = (primary, secondary, key) => {

    return primary !== undefined && primary[key] ? primary[key] : secondary[key];
}